import { Theme, BuilderBlockProps } from "@/types";
import { FC, ReactNode } from "react";

type ThemeBoxBlockProps = {
  children: ReactNode;
  theme: Theme;
} & BuilderBlockProps;
export const ThemeBoxBlock: FC<ThemeBoxBlockProps> = ({
  children,
  attributes,
  theme,
}) => (
  <div data-theme={theme} {...attributes}>
    {children}
  </div>
);
